
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
// import RewardContent from '../../components/Wallet/RewardSection';
// import WalletSection from '../../components/Wallet/WalletSection';
import CashWallets from '../../components/Wallet/CashWallets';

const TopCoinUKTax = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'TopCoin Uk  Tax Information'} pagesub={'Home'} />
               
                    <CashWallets/>              
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default  TopCoinUKTax;